/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module LogsModule */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { templatesConfiguration } from 'ng/modules/logs/constants/logs-signpost.constants';
import { ILogsSignpostTemplateConfig } from '../../../../logs.types';
import { ILogsSignpostStates, LogsSignpostStore } from '../../../../services/logs-signpost.store';
import './logs-signpost-default-header.component.less';

/**
 * @description Signpost header component, displays unique entries count and its respective details.
 * @author Suraj Kumar, Yogesh Patil
 */
@Component({
    selector: 'logs-signpost-default-header',
    templateUrl: './logs-signpost-default-header.component.html',
})
export class LogsSignpostDefaultHeaderComponent implements OnInit {
    /**
     * Selected signpost config key.
     */
    @Input()
    public configKey: string;

    /**
     * Selected signpost respective configuration in templatesConfiguration.
     */
    public activeTemplateConfig: ILogsSignpostTemplateConfig;

    constructor(public readonly logsSignpostStore: LogsSignpostStore<ILogsSignpostStates>) {}

    /** @override */
    public ngOnInit(): void {
        this.activeTemplateConfig = templatesConfiguration[this.configKey];
    }
}
